import type {FC} from 'react';
import {MdClose, MdOpenInNew} from 'react-icons/md';
import {CommonLink} from '../../../../shared/components/CommonLink';
import type {Heading} from '../../usecase/useCompanyDetailContents';

type Props = {
  headerContents: Heading[];
  hasReports: boolean;
  companyID: number;
  onClose: () => void;
};
/**
 * 目次モーダルのコンテンツ
 * 外殻のモーダルはMantineを使用
 */
export const ModalContent: FC<Props> = ({
  headerContents,
  hasReports,
  companyID,
  onClose,
}) => {
  return (
    <div>
      <h2 className="text-md pc:text-lg font-bold border-b-[1px] border-line flex justify-between">
        <button
          type="button"
          className="p-4 hover:pointer hover:opacity-50"
          onClick={onClose}
        >
          <MdClose size={20} />
        </button>

        <span>目次</span>
        <div />
      </h2>
      <ul onClick={onClose} className="list-none flex flex-col gap-y-12 pt-12">
        {headerContents?.map((content) => (
          <li key={content.id}>
            <CommonLink
              className="text-md hover:font-bold font-bold"
              href={`#${content.id}`}
              onClick={onClose}
            >
              {content.tagname}
            </CommonLink>
          </li>
        ))}
        {hasReports && (
          <li>
            <CommonLink
              className="text-md hover:font-bold font-bold flex items-center gap-x-4"
              href={`/company/${companyID}/experiences`}
            >
              ES・体験記
              <MdOpenInNew />
            </CommonLink>
          </li>
        )}
      </ul>
    </div>
  );
};
